// @flow

import React, { type Node } from 'react';
import { ThemeProvider } from 'styled-components';
import { type ShopifyTheme } from './types';

type Props = {|
  theme: ShopifyTheme,
  children: Node,
|};

export function ShopifyThemeProvider({ theme, children }: Props): Node {
  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}
